<template>
    <div class="text-xs">
        <ol>
            <li v-for="price in visiblePrices" :key="price.Quantity" class="flex p-0.5 gap-1 tabular-nums">
                <span>{{ price.FormattedQuantity }}</span>
                <span class="grow border-b-2 border-dotted relative -top-0.5" aria-hidden="true"></span>
                <span>{{ price.FormattedPrice }}</span>
            </li>
        </ol>

        <div v-if="showSeeMore" class="text-center">
            <Button variant="link" size="sm" @click="expandPricing">
                {{ $t("Search.SeeMore") }}
            </Button>
        </div>
    </div>
</template>
<script setup lang="ts">
import { useWindowSize } from "@vueuse/core";

const { gtag } = useGtag();
const { width: windowWidth } = useWindowSize();

const props = defineProps<{ prices: PartResultPrice[] }>();

const showAll = ref(false);

const isLargeWindow = computed(() => (import.meta.server ? true : windowWidth.value > 992));

const breakPoint = computed(() => (isLargeWindow.value ? 5 : 2));

const visiblePrices = computed(() =>
    (showAll.value ? props.prices : props.prices.slice(0, breakPoint.value)).map((p, index) => ({ ...p, index }))
);

const showSeeMore = computed(() => props.prices.length > breakPoint.value && !showAll.value);

function expandPricing() {
    gtag("event", "results_pricing_expand");
    showAll.value = true;
}
</script>
